// extracted by mini-css-extract-plugin
export default {"bulk-payment-links":"bulk-payment-links_bulk-payment-links__yThVt"};